import React, { useState } from "react";
import Widget from "rasa-webchat";
import io from 'socket.io-client';
import ComponentSelector from "./componentSelector";
import CustomizedButton from "./components/devMessageButton";
import Stack from '@mui/material/Stack';
import DevModal from "./components/devModal"
const Chatbot: React.FC<{
}> = ({ initPayload: string }) => {




  //let messageData=Widget.customComponent.messageData;

  // Bugfix in order to get the Enter Key working
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      try {
        // @ts-ignore
        // eslint-disable-next-line
        document.querySelector(".rw-send").click();
      } catch (e) {
        console.log(e);
      }
    }
  };
  //This is the JS version of url observer 
  //TODO: Translate to react use hooks
  var oldHref = document.location.href;
  window.onload = function () {
    var bodyList = document.querySelector("body")
    var pattern = new RegExp('.*(www|rent.)?akelius.*(co.uk|ca|[Ll]ondon|united-kingdom|[Tt]oronto|canada).*');
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (oldHref !== document.location.href) {
          oldHref = document.location.href;
          console.log("url has been changed")
          if (!oldHref.match(pattern)) {
            console.log("doesnt match");
            document.querySelector(".rasaWebchatPro").style.display = "none";
          }
          else { document.querySelector(".rasaWebchatPro").style.display = "block"; }
        }
      });
    });

    var config = {
      childList: true,
      subtree: true
    };

    observer.observe(bodyList, config);
  };

  //This is a fix for the iphone keyboard bug. As soon as webchat opens function clicks the background
  const clickBackground = () => {

    if (/iPhone|iPad|iPod/.test(window.navigator.userAgent)) {

      waitForElm('.rw-new-message').then(function (elm) {
        if (document.querySelector(".rw-new-message")) {
          document.activeElement.blur();
          document.querySelector("#rw-messages").click();
          console.log("this is run");

        }

      });
    }
  }
  // waits for the input to appear on screen. Should be refactored in the future to the useEffect hook
  const waitForElm = (selector) => {
    return new Promise(function (resolve) {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      var observer = new MutationObserver(function (mutations) {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }


  // This is a function that sends the modified initial payload via socket url
  const starting_payload = "hi";
  let count = 0;
  //const starting_payload = `/greet{"url": "https://website-development.development.azure.akelius.com/en/city/london"}`;
  // const starting_payload = `/greet{"url": "https://apartment-search-staging.production.azure.akelius.com/en/detail/united-kingdom/40051-32"}`;
  //const starting_payload = `/greet{"url": "https://apartment-search-staging.production.azure.akelius.com/en/search/united-kingdom/apartment/"}`;
  //"https://rasa-production-mal-development.development.azure.akelius.com/"
  let socket_url = process.env.REACT_APP_SOCKET_URL;
  //let socket_url= "https://rasa-production-mal-development.development.azure.akelius.com/"
  //let socket_url= "https://rasa-production-mal-production.production.azure.akelius.com/"

// function extractLanguageCodeFromUrl() {
//   const url = window.location.href; // Get the current URL
//   //const url = "https://apartment-search-staging.production.azure.akelius.com/fr/detail/united-kingdom/40051-32";
//   const languageCodeRegex = /\/([a-z]{2})\//i; // Regex pattern to match two-letter language code
//   
//   const matches = url.match(languageCodeRegex); // Find matches in the URL
//   
//   if (matches && matches.length >= 2) {
//     return matches[1]; // Return the captured language code
//   } else {
//     return "en"; // Return null if no language code found
//   }
// }

  const SendURL = (event: any) => {

    if (JSON.parse(sessionStorage.chat_session).conversation == null || JSON.parse(sessionStorage.chat_session).conversation.length <= 1) {
      if (count < 1) {
        var conversation_id = JSON.parse(window.sessionStorage.chat_session).session_id;
        console.log(conversation_id);
        let socket = io(socket_url);
        console.log(socket_url);
        socket.on('connect', () => {
          console.log("Connected to Socket.io server");
        });
        

        //var payload = '/inform{"url": "'.concat(window.location.href, '"}')
        //var payload = '/inform{"url":"'+window.location.href+'", "langcode": "' + extractLanguageCodeFromUrl() + '"}';
        var payload = '/inform{"url":"'+window.location.href+'", "langcode": "en"}';
        //var payload = '/inform{"langcode":"","url":"https://website-development.development.azure.akelius.com/fr/city/london"}';
        
        socket.emit('user_uttered',
          { "session_id": conversation_id, "message": payload }
        );
        count += 1;
      }
    }
  }


  const [shouldRenderButton, setShouldRenderButton] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");


  const checkElementExists = () => {
    const element = document.querySelector('.rw-widget-container.rw-chat-open');
    if (element) {
      renderButton();
    }
    else{
      setShouldRenderButton(false)
  };

  };
  const observer = new MutationObserver(checkElementExists);
  const targetNode = document.documentElement;
  const config = { childList: true, subtree: true };
 
  observer.observe(targetNode, config);

  const checkURL = () => {
    const urlKeywords = ['development','staging',"localhost"];
    const currentURL = window.location.href;
    //const currentURL =  "https://akelius.com/en/city/london";
    return urlKeywords.some(keyword => currentURL.includes(keyword));
  };
    

  const renderButton = () => {

    if ( checkURL()) {
      setShouldRenderButton(true);
      
    }
    
    else { setShouldRenderButton(false); }

  };





  return (



    <Stack>




      <div onKeyDown={handleKeyDown}>

        <Widget
          profileAvatar={"https://akeliuswebcontent.blob.core.windows.net/files/assets/icon_Akelius_931956b6d2.svg"}
          initPayload={starting_payload}
          socketUrl={process.env.REACT_APP_SOCKET_URL}
          socketPath={"/socket.io/"}
          customData={{ "language": "en" }} // arbitrary custom data. Stay minimal as this will be added to the socket
          title={"Akelius chat"}
          customComponent={(messageData) => (
            //Is triggered if we receive a custom json message from Rasa server or Action server
            <>
              {
                <>
                  <ComponentSelector messageData={messageData} clickedImg currentIndex />
                </>

                //chooses what component to render based on what type of component we want 
              }
            </>



          )


          }
          params={{ storage: "session" }}
          customMessageDelay={(message) => {
            var delay = message.length * 10;
            if (delay > 1000) delay = 1000;
            if (delay < 400) delay = 500;
            return delay;

          }}
          onWidgetEvent={{ onChatOpen(onWidgetEvent) { SendURL(); clickBackground();  } }}


        />

      </div >

      {shouldRenderButton && (
        <CustomizedButton showModal={showModal} setShowModal={setShowModal} />)}
      {showModal && (
        <DevModal showModal={showModal} setShowModal={setShowModal} setName={setName} name={name}/>)}

    </Stack>
  );
};

export default Chatbot;